import React from 'react';
import { Translate, withLocalize } from "react-localize-redux";

class ChartTooltipNotesRow extends React.Component {
    render() {
        const { notes, colSpan } = this.props;

        return (
            <>
                <tr><th><Translate id='Charts.AddEntityNotes' /></th><td>&nbsp;</td></tr>
                {notes.map((cn, i) => <tr key={i}><td colSpan={colSpan}> {cn.UpdatedFormated} - {cn.UserFirstName} {cn.UserLastName} - {cn.Note}</td></tr>)}
            </>
        );
    }
}

export default withLocalize(ChartTooltipNotesRow);